const _this = {

    $dom: {

    },

    vars: {

    },

    init: function () {

        if($('.results-for-year').length) {
            if (sessionStorage.getItem('year') != '') {
                $('.results-for-year').text(sessionStorage.getItem('year'));
            }
            if (sessionStorage.getItem('month') != '' && $('.results-for-month-srb').length) {
                let month;
                if(sessionStorage.getItem('month') == 1) {
                    month = 'Januar';
                } else if(sessionStorage.getItem('month') == 2) {
                    month = 'Februar';
                } else if(sessionStorage.getItem('month') == 3) {
                    month = 'Mart';
                } else if(sessionStorage.getItem('month') == 4) {
                    month = 'April';
                } else if(sessionStorage.getItem('month') == 5) {
                    month = 'Maj';
                } else if(sessionStorage.getItem('month') == 6) {
                    month = 'Jun';
                } else if(sessionStorage.getItem('month') == 7) {
                    month = 'Jul';
                } else if(sessionStorage.getItem('month') == 8) {
                    month = 'Avgust';
                } else if(sessionStorage.getItem('month') == 9) {
                    month = 'Septembar';
                } else if(sessionStorage.getItem('month') == 10) {
                    month = 'Oktobar';
                } else if(sessionStorage.getItem('month') == 11) {
                    month = 'Novembar';
                } else if(sessionStorage.getItem('month') == 12) {
                    month = 'Decembar';
                }

                $('.results-for-month-srb').text(month);
            }

            if (sessionStorage.getItem('month') != '' && $('.results-for-month-eng').length) {
                let month;
                if(sessionStorage.getItem('month') == 1) {
                    month = 'January';
                } else if(sessionStorage.getItem('month') == 2) {
                    month = 'February';
                } else if(sessionStorage.getItem('month') == 3) {
                    month = 'March';
                } else if(sessionStorage.getItem('month') == 4) {
                    month = 'April';
                } else if(sessionStorage.getItem('month') == 5) {
                    month = 'May';
                } else if(sessionStorage.getItem('month') == 6) {
                    month = 'June';
                } else if(sessionStorage.getItem('month') == 7) {
                    month = 'July';
                } else if(sessionStorage.getItem('month') == 8) {
                    month = 'August';
                } else if(sessionStorage.getItem('month') == 9) {
                    month = 'September';
                } else if(sessionStorage.getItem('month') == 10) {
                    month = 'October';
                } else if(sessionStorage.getItem('month') == 11) {
                    month = 'November';
                } else if(sessionStorage.getItem('month') == 12) {
                    month = 'December';
                }

                $('.results-for-month-eng').text(month);
            }
        }

        let windowsize = $(window).width();

        $(window).on('resize', function() {
            let windowsize = $(window).width();
        });

        if (windowsize < 1200) {
            $('.archive-popup-trigger').on('click', function() {
                $('.archive-mobile').toggleClass('active');
            });
        }

        $('.archive-popup-trigger').on('click', function() {
            $('.archive-popup').toggleClass('active');
        });

        if (sessionStorage.getItem('year') != '') {
            $('.archive-popup-select-year').val(sessionStorage.getItem('year'));
            let year = sessionStorage.getItem('year');
            jQuery.ajax({
                url: theme.ajax_url,
                data: {
                    action: 'dynamic_options',
                    year: year,
                },
                type: 'POST',
                success: function (data) {
                    if (data) {
                        $('.archive-popup-select-month').empty();
                        $('.archive-popup-select-month').append(data);
                        if (sessionStorage.getItem('month') != '') {
                            $('.archive-popup-select-month').prop('disabled', false);
                            $('.archive-popup-select-month').val(sessionStorage.getItem('month'));
                        }
                    }
                }
            });
        } else {
            $('.archive-popup-select-year').val('');
        }
        
        if (sessionStorage.getItem('year') != '') {
            $('.archive-popup-select-month').prop('disabled', false);
        } else {
            $('.archive-popup-select-month').prop('disabled', true);
            $('.archive-popup-select-month').val('');
        }
        $('.archive-popup-select-year').on('change', function () {
            sessionStorage.setItem('year', this.value);
            if (sessionStorage.getItem('year') != '') {
                $('.archive-popup-select-month').prop('disabled', false);
                let year = this.value;
                jQuery.ajax({
                    url: theme.ajax_url,
                    data: {
                        action: 'dynamic_options',
                        year: year,
                    },
                    type: 'POST',
                    success: function (data) {
                        if (data) {
                            $('.archive-popup-select-month').empty();
                            $('.archive-popup-select-month').append(data);
                        }
                    }
                });
            } else {
                $('.archive-popup-select-month').prop('disabled', true);
            }
        });

        $('.archive-popup-select-month').on('change', function () {
            sessionStorage.setItem('month', this.value);
        });

        $('.archive-popup-submit').on('click', function () {
            if (sessionStorage.getItem('year') == '') {
                return;
            } else if (sessionStorage.getItem('month') == '' || sessionStorage.getItem('month') == null) {
                window.location.href = theme.siteUrl + sessionStorage.getItem('year');
            } else {
                window.location.href = theme.siteUrl + sessionStorage.getItem('year') + '/' + sessionStorage.getItem('month');
            }
        });
    }

}

export default _this;